import React from "react";
import CheckoutItemCard from "../CheckoutItemCard";

export default function OrderSummary({
  cartItems,
  cartCount,
  cartGTotal,
  shippingCharges,
  actualTotal,
  cartDiscount,
  fiveGallonNotice,
  mosquePrices,
  deliveryOption,
  getRawPrice,
  getDisplayPrice,
  calculateTaxAmount,
  bottleDepositAmount,
  fiveGallonQty,
  fiveGallonItemId,
  partialDeliveryMinQty,
  partialDeliverySchedule,
  onSetUpPartialDelivery,
}) {
  return (
    <div className="max-w-7xl">
      {cartCount > 0 ? (
        <div>
          {cartItems.map((product) => (
            <CheckoutItemCard
              key={product.id}
              product={getDisplayPrice(product)}
              deliveryOption={deliveryOption}
              fiveGallonItemId={fiveGallonItemId}
              fiveGallonQty={fiveGallonQty}
              partialDeliveryMinQty={partialDeliveryMinQty}
              partialDeliverySchedule={partialDeliverySchedule}
              onSetUpPartialDelivery={onSetUpPartialDelivery}
            />
          ))}
          <div className="">
            <h2 className="sr-only">Order summary</h2>
            <dl className="mt-10 space-y-6 text-sm font-medium text-gray-500">
              <div className="flex justify-between">
                <dt>Items(s) Total</dt>
                <dd className="text-red-400 line-through">
                  {Number(actualTotal).toFixed(2)}
                </dd>
              </div>
              <div className="flex justify-between">
                <dt>Items(s) Discount</dt>
                <dd className="text-green-500">
                  {Number(cartDiscount).toFixed(2) || 0.0}
                </dd>
              </div>
              <div className="flex justify-between">
                <dt>Subtotal</dt>
                <dd className="text-gray-900">
                  {cartItems
                    .reduce(
                      (sum, item) =>
                        sum + getRawPrice(item) * parseInt(item.quantity || 1),
                      0
                    )
                    .toFixed(2)}
                </dd>
              </div>
              <div className="flex justify-between">
                <dt>VAT</dt>
                <dd className="text-gray-900">
                  {(
                    cartItems.reduce(
                      (sum, item) =>
                        sum +
                        calculateTaxAmount(
                          getRawPrice(item),
                          item.quantity || 1,
                          0.05
                        ),
                      0
                    ) || 0
                  ).toFixed(2)}
                </dd>
              </div>
              <div className="flex justify-between">
                <dt>Shipping</dt>
                <dd className="text-C12 text-red-500 max-w-20 w-40 font-poppins">
                  {cartGTotal < 75 ? `Minimum order 75 AED` : ""}
                </dd>
                <dd className="text-gray-900 ">{shippingCharges.toFixed(2)}</dd>
              </div>

              {bottleDepositAmount > 0 && (
                <div className="flex justify-between text-sm text-blue-600 mt-2 bg-blue-50 px-3 py-2 rounded">
                  <div className="flex items-center">
                    <svg
                      className="w-4 h-4 mr-2"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <p>Bottle Deposit (Refundable)</p>
                  </div>
                  <p className="font-semibold">
                    {bottleDepositAmount.toFixed(2)} AED
                  </p>
                </div>
              )}

              <div className="flex justify-between text-lg font-bold text-gray-900 mt-4 pt-4 border-t-2 border-gray-300">
                <dt className="text-base">Net Total</dt>

                <dd className="text-base">
                  {(cartGTotal + bottleDepositAmount).toFixed(2)}
                </dd>
              </div>
            </dl>

            {partialDeliverySchedule && (
              <div className="mt-6 bg-purple-50 border-2 border-purple-300 rounded-lg p-4">
                <h3 className="text-sm font-semibold text-purple-900 mb-2">
                  Split into {partialDeliverySchedule.deliveries.length} weekly
                  deliveries
                </h3>
                <p className="text-sm text-purple-800">
                  The full amount above (items + VAT + security deposit) will be
                  paid today and credited to your <strong>Zulal Wallet</strong>.
                  Each scheduled delivery will then be settled from your wallet
                  balance automatically, starting{" "}
                  {new Date(
                    partialDeliverySchedule.deliveries[0].date
                  ).toLocaleDateString()}
                  .
                </p>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="max-w-md">
          <span className="text-2xl text-center items-center justify-center">
            Your Cart is empty, please{" "}
            <a
              href="/productsrange"
              className="font-medium text-base text-primary hover:text-primaryHover mt-5 items-center justify-center "
            >
              Continue to Shop
              <span aria-hidden="true"> &rarr;</span>
            </a>
          </span>
          <img src="../../images/emptycart.jpg" className="" alt="" />
        </div>
      )}
    </div>
  );
}
